import { useRef, useEffect } from 'react';

const useWhenFontLoaded = (callback) => {
    const callbackRef = useRef(callback);
    useEffect(() => {
        void document.fonts.load('1em hh sans').then(() => {
            callbackRef.current();
        });
    }, [callbackRef]);
};

export { useWhenFontLoaded };
//# sourceMappingURL=useWhenFontLoaded.js.map
